import { calculateSpeed, GhostAI } from './GhostAI';
import Ghost from '../Ghost';

import { tileSize } from '~/src/consts/sizes';

export default class ScatterAI implements GhostAI {
	private readonly ghost: Ghost;
	public targetPosition: { x: number; y: number; };
	public speed = 0;


	constructor(targetX: number, targetY: number, ghost: Ghost) {
		const [x, y] = [targetX, targetY].map(t => (t + 1) * tileSize);
		this.targetPosition = { x, y };
		this.ghost = ghost;
		this.speed = (calculateSpeed(this.ghost.level - 1) - 2) * tileSize;
	}

	chooseTarget() {
		return;
	}
}
